const SELECTORS = {
    WIZARD: '.js-contact-wizard',
    STEPS: '.js-contact-wizard-steps',
    STEPS_ITEM: '.js-contact-wizard-steps-item',
    FORM_SECTION: '.js-contact-wizard-form-section',
    BACK: '.js-contact-wizard-form-back',
    SUBMIT: '.js-contact-wizard-submit',
    STEP_INPUT: '.js-contact-wizard-step-input',
};

const MODIFIERS = {
    FORM_SECTION: 'wizard__form__fieldset--active',
    BACK_LINK: 'wizard__form__controls__back--shown',
    FORM_GROUP_ERROR: 'form-group--has-error',
};

// eslint-disable-next-line max-len, no-useless-escape
const VALID_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export { SELECTORS, MODIFIERS, VALID_EMAIL_REGEX };
